var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Page",
    { staticClass: "company-flow" },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "/static/companies/" + _vm.company + ".svg" }
      }),
      _vm._v(" "),
      _vm.showBuyBox
        ? _c("BuyBox", { attrs: { company: _vm.company } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [_c("Questions", { attrs: { questions: _vm.questions } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c71d55d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c71d55d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/flows/Company/Company.vue
// module id = null
// module chunks = 